/**
 *
 * @type {HTMLElement[]}
 */
const ffSpinnersPool = [];

/**
 *
 * @returns {HTMLElement}
 */
const ffGenerateSpinner = () => {
  const newSpinner = document.createElement("span");
  newSpinner.className = "ff-spinner_wrapper";
  newSpinner.innerHTML = `
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
    <span class="ff-spinner_tile"></span>
  `;
  return newSpinner;
};

/**
 *
 * @returns {HTMLElement}
 */
const ffGetSpinner = () => {
  return ffSpinnersPool.pop() || ffGenerateSpinner();
};

/**
 *
 * @param {HTMLElement} spinner
 */
const ffReleaseSpinner = (spinner) => {
  spinner.remove();
  ffSpinnersPool.push(spinner);
};
